var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 35,
    rx: 4,
    fill: "#26A17B",
    stroke: "#26A17B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1416 22.675L27.0291 12.7875C27.2625 12.5542 27.5395 12.4375 27.8604 12.4375C28.1812 12.4375 28.4583 12.5542 28.6916 12.7875C28.925 13.0208 29.0416 13.2979 29.0416 13.6187C29.0416 13.9396 28.925 14.2167 28.6916 14.45L17.9583 25.1833C17.725 25.4167 17.4527 25.5333 17.1416 25.5333C16.8305 25.5333 16.5583 25.4167 16.325 25.1833L11.3083 20.1667C11.075 19.9333 10.9632 19.6562 10.9729 19.3354C10.9826 19.0146 11.1041 18.7375 11.3375 18.5042C11.5708 18.2708 11.8479 18.1542 12.1687 18.1542C12.4895 18.1542 12.7666 18.2708 13 18.5042L17.1416 22.675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c8ff8a88f13581e01749239b266298ad.svg";
export { ForwardRef as ReactComponent };